import { Controller } from 'stimulus'
import $ from 'jquery'
import dropdown from 'semantic-ui-dropdown'
import transition from 'semantic-ui-transition'

$.fn.dropdown = dropdown
$.fn.transition = transition

export default class extends Controller {
  static targets = ['value', 'installments', 'paymentMethod', 'cardNsu', 'cardBrand']

  connect() {
    this.handleChange()
    this.toggleInstallments()
    this.toggleCreditCardExtras()
    this.manageBilletAvailability()
    this.initializeRemovalListener()
  }

  initializeRemovalListener() {
    const paymentsContainer = document.querySelector('[data-component="budget-payments"], [data-attr="budget-payments-container"]')
    if (!paymentsContainer) return

    const self = this
    $(paymentsContainer)
      .on('cocoon:after-remove', function(e) {
        setTimeout(function() {
          self.manageBilletAvailability()
          self.refreshAllDropdowns()
        }, 300)
      })
  }

  handleChange() {
    const calcValue = this.calcPayment()

    this.data.set('total-value', calcValue)
    this.notifyChange()
  }

  toggleCreditCardExtras() {
    if (this.data.get('handle-credit-extras') != 'true') return
    if (!this.hasCardNsuTarget || !this.hasCardBrandTarget) return

    const paymentWithCreditExtra = ['credit_card', 'debit_card']
    const paymentWithTicketsExtra = ['va_ticket', 'vr_ticket', 'gift_ticket', 'fuel_ticket']

    if (paymentWithCreditExtra.indexOf(this.paymentMethodTarget.value) >= 0 ) {
      this.cardNsuTarget.classList.remove('is-disabled')
      this.cardBrandTarget.classList.remove('is-disabled')
    } else if (paymentWithTicketsExtra.indexOf(this.paymentMethodTarget.value) >= 0 ) {
      this.cardNsuTarget.classList.remove('is-disabled')
      this.cardBrandTarget.classList.add('is-disabled')
    } else {
      this.cardNsuTarget.classList.add('is-disabled')
      this.cardBrandTarget.classList.add('is-disabled')
    }
  }

  toggleInstallments() {
    if (this.data.get('handle-installments') != 'true') return
    if (!this.hasInstallmentsTarget) return

    const paymentWithInstallments = ['credit_card', 'creditor', 'billet', 'others']
    const $fieldContainer = $(this.installmentsTarget).parents('.field')

    if (paymentWithInstallments.indexOf(this.paymentMethodTarget.value) >= 0 ) {
      $fieldContainer.removeClass('is-disabled')
      $fieldContainer.children().removeClass('disabled')
    } else {
      $fieldContainer.find('.item[data-value="1"]').trigger('click')
      $fieldContainer.addClass('is-disabled')
      $fieldContainer.children().addClass('disabled')
    }
  }

  handlePaymentMethodChange() {
    this.toggleInstallments()
    this.toggleCreditCardExtras()
    this.manageBilletAvailability()
  }

  manageBilletAvailability() {
    const paymentsContainer = document.querySelector('[data-component="budget-payments"], [data-attr="budget-payments-container"]')
    if (!paymentsContainer) return

    const paymentRows = Array.from(paymentsContainer.querySelectorAll('tr.nested-fields:not(.installment-row)'))

    // Verificar se existe algum billet selecionado e não marcado para destruição
    let billetRowIndex = -1
    paymentRows.forEach((row, index) => {
      const methodSelect = row.querySelector('select[name*="[payment_method]"]')
      const destroyField = row.querySelector('input[name*="[_destroy]"]')

      if (methodSelect && methodSelect.value === 'billet' && (!destroyField || destroyField.value !== 'true')) {
        billetRowIndex = index
      }
    })

    // Gerenciar opção de billet em todos os selects
    paymentRows.forEach((row, index) => {
      const methodSelect = row.querySelector('select[name*="[payment_method]"]')
      if (!methodSelect) return

      let billetOption = methodSelect.querySelector('option[value="billet"]')
      const billetBackup = paymentsContainer.querySelector('[data-billet-option-backup]')

      if (billetRowIndex !== -1) {
        // Existe um billet selecionado
        if (index !== billetRowIndex) {
          // Esta linha NÃO tem billet: remover a opção
          if (billetOption && !row.querySelector('[data-billet-option-backup]')) {
            const backup = billetOption.cloneNode(true)
            backup.setAttribute('data-billet-option-backup', 'true')
            backup.style.display = 'none'
            row.appendChild(backup)
            billetOption.remove()
          }
        } else {
          // Esta é a linha com billet: garantir que tem a opção
          if (!billetOption && billetBackup) {
            const restored = billetBackup.cloneNode(true)
            restored.removeAttribute('data-billet-option-backup')
            restored.style.display = ''
            methodSelect.appendChild(restored)
            billetBackup.remove()
          }
        }
      } else {
        // Não há billet: restaurar a opção em todos os selects
        const localBackup = row.querySelector('[data-billet-option-backup]')
        if (localBackup && !billetOption) {
          const restored = localBackup.cloneNode(true)
          restored.removeAttribute('data-billet-option-backup')
          restored.style.display = ''
          methodSelect.appendChild(restored)
          localBackup.remove()
        }
      }
    })
  }

  refreshAllDropdowns() {
    const paymentsContainer = document.querySelector('[data-component="budget-payments"], [data-attr="budget-payments-container"]')
    if (!paymentsContainer) return

    const paymentRows = paymentsContainer.querySelectorAll('tr.nested-fields:not(.installment-row)')

    paymentRows.forEach((row) => {
      const methodSelect = row.querySelector('select[name*="[payment_method]"]')
      if (!methodSelect) return

      // Apenas fazer refresh para atualizar a lista sem destruir
      $(methodSelect).dropdown('refresh')
    })
  }

  calcPayment() {
    return (Number(this.valueTarget.value || 0))
  }

  notifyChange() {
    const customEvent = new CustomEvent('paymentChanged')
    window.dispatchEvent(customEvent)
  }
}
